const PAYROLL_PROCESS_EMPLOYEE_DEDUCTION_TYPE = Object.freeze({
    RECURRING : "RECURRING",
    ADJUSTMENT : "ADJUSTMENT"
});

export {
    PAYROLL_PROCESS_EMPLOYEE_DEDUCTION_TYPE
};